import { get, isEmpty } from 'lodash';

export class ContactForm {
  salutation: string | undefined;
  givname: string | undefined;
  surname: string | undefined;
  mobileNum: string | undefined;
  emailId: string | undefined;
  isAvivaCustomer: string | undefined;
  nric?: string;
  dob?: string;

  constructor(initial: any) {
    this.salutation = get(initial, 'salutation', undefined);
    const givname = get(initial, 'givname', undefined);
    this.givname = isEmpty(givname) ? undefined : givname;
    const surname = get(initial, 'surname', undefined);
    this.surname = isEmpty(surname) ? undefined : surname;
    const mobileNum = get(initial, 'mobileNum', undefined);
    this.mobileNum =  isEmpty(mobileNum) ? undefined : mobileNum;
    const emailId = get(initial, 'emailId', undefined);
    this.emailId = isEmpty(emailId) ? undefined : emailId;
    this.dob = get(initial, 'dob', undefined);
    this.isAvivaCustomer = get(initial, 'isAvivaCustomer', undefined);
    this.nric = get(initial, 'nric', undefined);
  }
}